import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { showErrorPopup } from '../../actions/notification-actions';
import { verifyUserMagicLink } from '../../actions';
import { applyPostLoginRedirect, resolvePostLoginRedirect } from '../../utils/loginRedirect';
import { resolveMagicLinkRoute } from '../../utils/magicLinkRedirect';

const loginPath = '/login';
const platform = 'web';

const MagicLinkVerificationPage = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const authError = useSelector((state) => state.auth?.error);
    const user = useSelector((state) => state.auth?.user);
    const callbackUrl = useSelector((state) => state.auth?.magicLinkCallbackUrl);
    const activateUtr = useSelector((state) => state.activateUtr);

    const handleOnCloseErrorPopup = () => {
        history.push(loginPath);
    };

    const displayErrorPopup = () => {
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Something went wrong while verifying your login link',
            onConfirmClick: handleOnCloseErrorPopup,
            onCancelClick: handleOnCloseErrorPopup,
        }));
    };

    useEffect(() => {
        const tokenHash = location?.hash?.split('=')[1];
        if (tokenHash) {
            dispatch(verifyUserMagicLink({ token: tokenHash, platform }));
        } else {
            displayErrorPopup();
        }
    }, []);

    useEffect(() => {
        if (authError) {
            displayErrorPopup();
         }
    }, [authError]);

    useEffect(() => {
        if (user) {
            const route = resolveMagicLinkRoute(user, callbackUrl);
            if (route) {
                history.replace(route);
                return;
            }
            applyPostLoginRedirect(
                resolvePostLoginRedirect({ next: callbackUrl }, activateUtr, user),
                history,
            );
        }
    }, [user]);

    return null;
};

export default MagicLinkVerificationPage;
